import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import AddModalHeader from "./AddModalHeader";
import { Form, Button, Row, Col, Dropdown } from 'react-bootstrap';
import "../../assets/scss/CSVUpload.css";
import { FaDownload, FaSpinner } from "react-icons/fa";
const AddModal = ({
  isOpen,
  toggleModal,
  file,
  setFile,
  setError,
  error,
  uploadLoading,
  handleSubmit,
  modalTitle,
  btnLabel,
  handleChange,
  fieldData,
  selectedIndustry,
  setSelectedIndustry,
  setShowSampleFile,
  showSampleFile
}) => {

  const [industryLabel, setIndustryLabel] = useState("");
  const [columnNotes, setColumnNotes] = useState("");
  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFile = event.dataTransfer.files[0];
    validateFile(droppedFile);
  };
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      validateFile(selectedFile);

      // Reset the input field so selecting the same file again works
      event.target.value = "";
    }
  };

  const validateFile = (file) => {
    if (file) {
      const allowedExtensions = ["csv", "xlsx"];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (allowedExtensions.includes(fileExtension)) {
        setFile(file);
        setError("");
      } else {
        setError("Please upload a valid CSV file.");
        setFile(null);
      }
    } else {
      setError("Please upload a valid file.");
      setFile(null);
    }
  };

  const notesSwitchCase = (industry) => {
    switch(industry){
      case 'COMPANY':
        return 'Mendatory fields are : ORIGINAL_EXPORTER, EXPORTER_ADDRESS or ORIGINAL_IMPORTER, IMPORTER_ADDRESS'
      default:
        return 'Mendatory fields are : PRODUCT';
    }

  }
  const handleIndustrySelect = (industry) => {
    setIndustryLabel(industry.label)
    setSelectedIndustry(industry.value);
    setColumnNotes(notesSwitchCase(industry.value));
    setShowSampleFile(true);
  };



  return (
    <Modal isOpen={isOpen} toggle={toggleModal} style={{ overflow: "visible" }}>
      <AddModalHeader {...{ modalTitle, toggleModal }} />
      <ModalBody>
        { modalTitle === "Add User" ? (
          <>
          <Row className="mb-3">
      <Form.Label column sm={3}>First Name:</Form.Label>
      <Col sm={9}>
        <Form.Control
          type="text"
          placeholder="First Name"
          name="firstName"
          value={fieldData?.firstName}
          onChange={handleChange}
          required
        />
      </Col>
    </Row>
    <Row className="mb-3">
      <Form.Label column sm={3}>Last Name:</Form.Label>
      <Col sm={9}>
        <Form.Control
          type="text"
          placeholder="Last Name"
          name="lastName"
          value={fieldData?.lastName}
          onChange={handleChange}
          required
        />
      </Col>
    </Row>


            <Row className="mb-3">
              <Form.Label column sm={3}>Email:</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="email"
                  placeholder="Email"
                  name="email"
                  value={fieldData?.email}
                  onChange={handleChange}
                  required />
              </Col>
            </Row><Row className="mb-3">
              <Form.Label column sm={3}>Password:</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="password"
                  placeholder="Password"
                  name="password"
                  value={fieldData?.password}
                  onChange={handleChange}
                  required />
              </Col>
            </Row><Row className="mb-3">
              <Form.Label column sm={3}>Role:</Form.Label>
              <Col sm={9}>
                <Form.Control
                  as="select"
                  name="role"
                  value={fieldData?.role}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select User Role</option>
                  <option value="user">User</option>
                  <option value="admin">Admin</option>
                  <option value="superadmin">Super Admin</option>
                  <option value="viewuser">View User</option>
                </Form.Control>
              </Col>
            </Row>
            <Col>
              <Button
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit(modalTitle === "Add User" ? { ...fieldData } : handleSubmit);
                }}
                style={{
                  backgroundColor: "#4b38b3",
                  marginLeft: "auto",
                  display: "block",
                  width: '100%'
                }}
              >
                {btnLabel}
              </Button>
            </Col>
          </>
        ) :  modalTitle === "Add Record" ? (
          <>
          <Row className="mb-3">
      <Form.Label column sm={5}>UniqueName:</Form.Label>
      <Col sm={9}>
        <Form.Control
          type="text"
          placeholder="Product UniqueName"
          name="ProductUniqueName"
          value={fieldData?.ProductUniqueName}
          onChange={handleChange}
          required
        />
      </Col>
    </Row>
    <Row className="mb-3">
      <Form.Label column sm={3}>Product Group</Form.Label>
      <Col sm={9}>
        <Form.Control
          type="text"
          placeholder="Product Group"
          name="ProductGroup"
          value={fieldData?.ProductGroup}
          onChange={handleChange}
          required
        />
      </Col>
    </Row>
     <Row className="mb-3">
              <Form.Label column sm={3}>CAS No</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  placeholder="CAS No."
                  name="CASNo"
                  value={fieldData?.CASNo}
                  onChange={handleChange}
                  required />
              </Col>
            </Row><Row className="mb-3">
              <Form.Label column sm={3}>Part</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  placeholder="Part"
                  name="Part"
                  value={fieldData?.Part}
                  onChange={handleChange}
                  required />
              </Col>
            </Row>
            <Row className="mb-3">
              <Form.Label column sm={3}>ATC Category</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  placeholder="Main ATC Category"
                  name="MainATCCategory"
                  value={fieldData?.MainATCCategory}
                  onChange={handleChange}
                  required />
              </Col>
            </Row>
            <Row className="mb-3">
              <Form.Label column sm={3}>SubCategory 1</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  placeholder="SubCategory 1"
                  name="SubCategory1"
                  value={fieldData?.SubCategory1}
                  onChange={handleChange}
                  required />
              </Col>
            </Row>
            <Row className="mb-3">
              <Form.Label column sm={3}>SubCategory 2</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  placeholder="SubCategory 2"
                  name="SubCategory2"
                  value={fieldData?.SubCategory2}
                  onChange={handleChange}
                  required />
              </Col>
            </Row>
            <Row className="mb-3">
              <Form.Label column sm={3}>SubCategory 3</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  placeholder="SubCategory 3"
                  name="SubCategory3"
                  value={fieldData?.SubCategory3}
                  onChange={handleChange}
                  required />
              </Col>
            </Row>

            <Col>
              <Button
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit(modalTitle === "Add Record" ? { ...fieldData } : handleSubmit);
                }}
                style={{
                  backgroundColor: "#4b38b3",
                  marginLeft: "auto",
                  display: "block",
                  width: '100%'
                }}
              >
                {btnLabel}
              </Button>
            </Col>
          </>
        )  : modalTitle === "Add File Company" ?  (
          <>
          <div style={{ position: "relative" }}>
            <div
              className="upload-box"
              onDragOver={(e) => e.preventDefault()}
              onDrop={handleDrop}
              onClick={(e) => {
                if (e.target.id !== "fileInput") {
                  document.getElementById("fileInput").click();
                }
              }}
            >
              <div className="upload-text">
                {file ? file.name : "Drop XLSX file here or click to upload"}
              </div>
              <input
                type="file"
                id="fileInput"
                accept=".xlsx"
                className="file-input"
                onChange={handleFileChange} />
              {error && <div className="error-text">{error}</div>}
            </div>
          </div><Row className="mb-3 align-items-center justify-content-between">
              <Col sm={4}>
                <Dropdown>
                  <Dropdown.Toggle id="dropdown-basic" style={{ width: '100%' }} >
                    {industryLabel || 'Select Industry'}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item 
                      onClick={() => handleIndustrySelect({value:'COMPANY', label: 'COMPANY'})}
                    >COMPANY</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              {showSampleFile && (
                <Col sm={4}>
                  <Button style={{ width: '100%' }}
                    onClick={() => {
                      const link = document.createElement("a");
                      link.href = selectedIndustry === "Nutra" ? "/nutra-sample.csv" : selectedIndustry === "Pharmaceutical" ? "/sample-input.csv" : selectedIndustry === "Cosmetic" ? "/cosmetics-sample.csv" : "/sample-input.csv";
                      link.setAttribute("download", "sample-input.csv");
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}>
                    <FaDownload style={{ fontSize: 16, marginRight: 5 }} />
                    Sample File
                  </Button>
                </Col>
              )}
              <Col sm={4}>
                <Button
                  type="submit"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubmit(modalTitle === "Add User" ? { ...fieldData } : handleSubmit);
                  }}
                  style={{
                    backgroundColor: "#4b38b3",
                    marginLeft: "auto",
                    display: "block",
                    width: '100%'
                  }}
                >
                  {btnLabel}
                </Button>
              </Col>
            </Row>
            <Row className="mb-3 align-items-center justify-content-between">
              <span style={{color: "blue", fontSize:"12"}}>{columnNotes}</span>
            </Row></>
        ):(
          <>
          <div style={{ position: "relative" }}>
            <div
              className="upload-box"
              onDragOver={(e) => e.preventDefault()}
              onDrop={handleDrop}
              onClick={(e) => {
                if (e.target.id !== "fileInput") {
                  document.getElementById("fileInput").click();
                }
              }}
            >
              <div className="upload-text">
                {file ? file.name : "Drop XLSX file here or click to upload"}
              </div>
              <input
                type="file"
                id="fileInput"
                accept=".xlsx"
                className="file-input"
                onChange={handleFileChange} />
              {error && <div className="error-text">{error}</div>}
            </div>
          </div><Row className="mb-3 align-items-center justify-content-between">
              <Col sm={4}>
                <Dropdown>
                  <Dropdown.Toggle id="dropdown-basic" style={{ width: '100%' }}>
                    {industryLabel || 'Select Industry'}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => handleIndustrySelect({value:'CH28', label: 'CH-28'})}>CH-28</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleIndustrySelect({value:'PHARMACUATICALS', label: 'CH-29'})}>CH-29</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleIndustrySelect({value:'FORMULATIONS', label: 'CH-30'})}>CH-30</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleIndustrySelect({value:'XIPIENTS', label: 'CH-Excipients'})}>CH-Excipients</Dropdown.Item>
                    {/* <Dropdown.Item onClick={() => handleIndustrySelect('Cosmetic')}>Cosmetic</Dropdown.Item> */}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              {showSampleFile && (
                <Col sm={4}>
                  <Button style={{ width: '100%' }}
                    onClick={() => {
                      const link = document.createElement("a");
                      link.href = selectedIndustry === "Nutra" ? "/nutra-sample.csv" : selectedIndustry === "Pharmaceutical" ? "/sample-input.csv" : selectedIndustry === "Cosmetic" ? "/cosmetics-sample.csv" : "/sample-input.csv";
                      link.setAttribute("download", "sample-input.csv");
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}>
                    <FaDownload style={{ fontSize: 16, marginRight: 5 }} />
                    Sample File
                  </Button>
                </Col>
              )}
              <Col sm={4}>
                <Button
                  type="submit"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubmit(modalTitle === "Add User" ? { ...fieldData } : handleSubmit);
                  }}
                  style={{
                    backgroundColor: "#4b38b3",
                    marginLeft: "auto",
                    display: "block",
                    width: '100%'
                  }}
                >
                  {btnLabel}
                </Button>
              </Col>
            </Row>
            <Row className="mb-3 align-items-center justify-content-between">
              <span style={{color: "blue", fontSize:"12"}}>{columnNotes}</span>
            </Row></>
        )}
      </ModalBody>
    </Modal>
  );
};

export default AddModal;
